import { render, staticRenderFns } from "./addrlist.vue?vue&type=template&id=689152d5&scoped=true&"
import script from "./addrlist.vue?vue&type=script&lang=js&"
export * from "./addrlist.vue?vue&type=script&lang=js&"
import style1 from "./addrlist.vue?vue&type=style&index=1&id=689152d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689152d5",
  null
  
)

export default component.exports